export enum AppointmentType {
  game = "game",
  supervisor = "supervisor",
  administrator = "administrator",
}
